import React from "react";
import { Box, Text, Spinner as SpinnerGrommet } from "grommet";

export const Spinner = () => (
  <Box align="center" direction="row" pad="small" gap="small" fill alignContent="center" alignSelf="center" justify="center">
    <SpinnerGrommet
      size="xsmall"
      border={[
        { side: 'all', color: 'transparent', size: 'medium' },
        { side: 'horizontal', color: 'brand', size: 'medium' },
      ]}
    />
  </Box>
);

export function SpinnerDots() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <circle cx="4" cy="12" r="3" opacity="1">
        <animate id="spinner_qYjJ" begin="0;spinner_t4KZ.end-0.25s" attributeName="opacity" dur="0.75s" values="1;.2" fill="freeze" />
      </circle>
      <circle cx="12" cy="12" r="3" opacity=".4">
        <animate begin="spinner_qYjJ.begin+0.15s" attributeName="opacity" dur="0.75s" values="1;.2" fill="freeze" />
      </circle>
      <circle cx="20" cy="12" r="3" opacity=".3">
        <animate id="spinner_t4KZ" begin="spinner_qYjJ.begin+0.3s" attributeName="opacity" dur="0.75s" values="1;.2" fill="freeze" />
      </circle>
    </svg>
  );
}

export const SpinnerAthena = ({ addtionalMessage = "" }) => (
  <Box align="center" direction="column" pad="small" gap="small" fill alignContent="center" alignSelf="center" justify="center">
    <SpinnerGrommet
      size="xsmall"
      border={[
        { side: 'all', color: 'transparent', size: 'medium' },
        { side: 'horizontal', color: 'brand', size: 'medium' },
      ]}
    />
    <Text weight="bold" size="small">Querying Athena Database...</Text>
    {addtionalMessage && <Text size="small">{addtionalMessage}</Text>}
    <Text size="small">This may take up to a minute please wait</Text>
  </Box>
);

export const SpinnerZK = ({ addtionalMessage = "" }) => (
  <Box align="center" direction="column" pad="small" gap="small" fill alignContent="center" alignSelf="center" justify="center">
    <SpinnerGrommet
      size="xsmall"
      border={[
        { side: 'all', color: 'transparent', size: 'medium' },
        { side: 'horizontal', color: 'brand', size: 'medium' },
      ]}
    />
    <Text weight="bold" size="small">Querying Zookeeper API Stats...</Text>
    {addtionalMessage && <Text size="small">Loading {addtionalMessage} ipAddresses</Text>}
    <Text size="small">This may take up to a minute please wait</Text>
  </Box>
);

export default Spinner;
